import React from 'react';
import { Flower2, Star, ShieldCheck, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-gradient-to-b from-pilates-soft to-pilates-cream overflow-hidden pt-5 pb-10 sm:pt-10 sm:pb-16 px-4 sm:px-6 lg:px-8" data-id="element-114">
      {/* Subtle decorative blobs */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-pilates-sage/20 rounded-full blur-3xl pointer-events-none" data-id="element-115"></div>
      <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] bg-pilates-lavender/20 rounded-full blur-3xl pointer-events-none" data-id="element-116"></div>

      <div className="relative max-w-3xl mx-auto flex flex-col items-center text-center z-10" data-id="element-117">
        <div className="flex items-center gap-2 mb-3 sm:mb-6" data-id="element-118">
          <Flower2 className="w-4 h-4 sm:w-5 sm:h-5 text-pilates-sage-dark" data-id="element-119" />
          <span className="font-display font-semibold text-pilates-dark text-base sm:text-lg tracking-[0.25em] uppercase" data-id="element-120">
            Pilates Prêt
          </span>
          <span className="text-sm" data-id="element-121">🇫🇷</span>
        </div>

        <div className="bg-white/70 backdrop-blur-sm border border-pilates-sage/30 text-pilates-sage-dark font-medium text-[10px] sm:text-sm px-3 sm:px-4 py-1 sm:py-1.5 rounded-full mb-4 sm:mb-8 flex items-center gap-2 shadow-sm" data-id="element-122">
          <span data-id="element-123">✨</span> MÉTHODE D'ENSEIGNEMENT VALIDÉE
        </div>

        <h1 className="font-display sm:text-5xl md:text-6xl font-medium text-pilates-dark leading-[1.15] sm:leading-[1.05] mb-3 sm:mb-6 tracking-tight ml-[15px] text-[28px]" data-id="element-124">
          Le Système Complet de{' '}
          <span className="italic text-pilates-sage-dark" data-id="element-125">Planification</span>{' '}
          pour Instructeurs de Pilates
        </h1>

        <p className="text-sm sm:text-lg text-pilates-slate max-w-xl mb-5 sm:mb-10 leading-relaxed px-2 sm:px-0" data-id="element-126">
          Gagnez du temps, retrouvez votre sérénité et élevez le niveau de vos
          cours — sans l'épuisement de la planification manuelle.
        </p>

        <div className="mb-5 sm:mb-10 max-w-[290px] sm:max-w-xl mx-auto w-full" data-id="element-127">
          <img src="https://cdn.magicpatterns.com/uploads/988bYnGKoQkwizPHuxZ3Jx/heylloyd-image-1779985889202.webp" alt="Coffret Pilates Prêt 6 livres en 1" className="w-full rounded-2xl shadow-2xl" data-id="element-128" />
        </div>

        <a href="#pricing-card" className="group relative inline-flex items-center justify-center gap-2 sm:gap-3 bg-gradient-to-r from-pilates-rose to-pilates-rose-dark text-white font-semibold text-sm sm:text-lg py-3 sm:py-4 px-6 sm:px-12 rounded-full shadow-[0_10px_30px_rgba(201,123,99,0.35)] hover:shadow-[0_15px_40px_rgba(201,123,99,0.5)] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto pt-[20px] pb-[20px]" data-id="element-129">
          <span data-id="element-130">🌿 Je veux ma Méthode maintenant</span>
          <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" data-id="element-131" />
        </a>

        <div className="mt-4 sm:mt-6 flex flex-col items-center gap-1.5 sm:gap-2" data-id="element-132">
          <div className="flex items-center gap-2" data-id="element-133">
            <div className="flex text-pilates-rose" data-id="element-134">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="currentColor" data-id="element-135" />)}
            </div>
            <span className="text-pilates-slate text-xs sm:text-sm font-medium" data-id="element-136">
              4.9/5 — avis vérifiés
            </span>
          </div>
          <div className="flex items-center gap-2 text-pilates-slate text-xs sm:text-sm" data-id="element-137">
            <ShieldCheck className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-pilates-sage-dark" data-id="element-138" />
            <span data-id="element-139">Garantie de 30 Jours — Risque Zéro</span>
          </div>
        </div>
      </div>
    </section>;
}